/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AdminRouteRouteImport } from './routes/admin/route'
import { Route as AppRouteRouteImport } from './routes/_app/route'
import { Route as AdminIndexRouteImport } from './routes/admin/index'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AdminUbicacionesRouteImport } from './routes/admin/ubicaciones'
import { Route as AdminSubidasRouteImport } from './routes/admin/subidas'
import { Route as AdminMiscomisionesRouteImport } from './routes/admin/miscomisiones'
import { Route as AdminLoginRouteImport } from './routes/admin/login'
import { Route as AdminInformesRouteImport } from './routes/admin/informes'
import { Route as AdminFotosRouteImport } from './routes/admin/fotos'
import { Route as AdminEditorRouteImport } from './routes/admin/editor'
import { Route as AdminCuentasRouteImport } from './routes/admin/cuentas'
import { Route as AdminComisionesFRouteImport } from './routes/admin/comisionesF'
import { Route as AdminComisionesRouteImport } from './routes/admin/comisiones'
import { Route as AppSubidasRouteImport } from './routes/_app/subidas'
import { Route as AppPedidosRouteImport } from './routes/_app/pedidos'
import { Route as AppPedidoRouteImport } from './routes/_app/pedido'
import { Route as AppLoginRouteImport } from './routes/_app/login'
import { Route as AppEditorRouteImport } from './routes/_app/editor'
import { Route as AppBuscadorRouteImport } from './routes/_app/buscador'
import { Route as AdminPedidosIndexRouteImport } from './routes/admin/pedidos/index'
import { Route as AdminPedidoIndexRouteImport } from './routes/admin/pedido/index'
import { Route as AdminConfigIndexRouteImport } from './routes/admin/config/index'
import { Route as AdminPedidosPrintRouteImport } from './routes/admin/pedidos/print'
import { Route as AdminPedidosCerradosRouteImport } from './routes/admin/pedidos/cerrados'
import { Route as AdminPedidoAnularRouteImport } from './routes/admin/pedido/anular'
import { Route as AdminConfigTemporadaRouteImport } from './routes/admin/config/temporada'
import { Route as AdminConfigPersonalRouteImport } from './routes/admin/config/personal'
import { Route as AdminConfigEditFotoRouteImport } from './routes/admin/config/editFoto'

const AdminRouteRoute = AdminRouteRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRouteRoute = AppRouteRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AdminUbicacionesRoute = AdminUbicacionesRouteImport.update({
  id: '/ubicaciones',
  path: '/ubicaciones',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminSubidasRoute = AdminSubidasRouteImport.update({
  id: '/subidas',
  path: '/subidas',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminMiscomisionesRoute = AdminMiscomisionesRouteImport.update({
  id: '/miscomisiones',
  path: '/miscomisiones',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminLoginRoute = AdminLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminInformesRoute = AdminInformesRouteImport.update({
  id: '/informes',
  path: '/informes',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminFotosRoute = AdminFotosRouteImport.update({
  id: '/fotos',
  path: '/fotos',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminEditorRoute = AdminEditorRouteImport.update({
  id: '/editor',
  path: '/editor',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminCuentasRoute = AdminCuentasRouteImport.update({
  id: '/cuentas',
  path: '/cuentas',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminComisionesFRoute = AdminComisionesFRouteImport.update({
  id: '/comisionesF',
  path: '/comisionesF',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminComisionesRoute = AdminComisionesRouteImport.update({
  id: '/comisiones',
  path: '/comisiones',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AppSubidasRoute = AppSubidasRouteImport.update({
  id: '/subidas',
  path: '/subidas',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppPedidosRoute = AppPedidosRouteImport.update({
  id: '/pedidos',
  path: '/pedidos',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppPedidoRoute = AppPedidoRouteImport.update({
  id: '/pedido',
  path: '/pedido',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppLoginRoute = AppLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppEditorRoute = AppEditorRouteImport.update({
  id: '/editor',
  path: '/editor',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppBuscadorRoute = AppBuscadorRouteImport.update({
  id: '/buscador',
  path: '/buscador',
  getParentRoute: () => AppRouteRoute,
} as any)
const AdminPedidosIndexRoute = AdminPedidosIndexRouteImport.update({
  id: '/pedidos/',
  path: '/pedidos/',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminPedidoIndexRoute = AdminPedidoIndexRouteImport.update({
  id: '/pedido/',
  path: '/pedido/',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminConfigIndexRoute = AdminConfigIndexRouteImport.update({
  id: '/config/',
  path: '/config/',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminPedidosPrintRoute = AdminPedidosPrintRouteImport.update({
  id: '/pedidos/print',
  path: '/pedidos/print',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminPedidosCerradosRoute = AdminPedidosCerradosRouteImport.update({
  id: '/pedidos/cerrados',
  path: '/pedidos/cerrados',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminPedidoAnularRoute = AdminPedidoAnularRouteImport.update({
  id: '/pedido/anular',
  path: '/pedido/anular',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminConfigTemporadaRoute = AdminConfigTemporadaRouteImport.update({
  id: '/config/temporada',
  path: '/config/temporada',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminConfigPersonalRoute = AdminConfigPersonalRouteImport.update({
  id: '/config/personal',
  path: '/config/personal',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminConfigEditFotoRoute = AdminConfigEditFotoRouteImport.update({
  id: '/config/editFoto',
  path: '/config/editFoto',
  getParentRoute: () => AdminRouteRoute,
} as any)

export interface FileRoutesByFullPath {
  '/admin': typeof AdminRouteRouteWithChildren
  '/buscador': typeof AppBuscadorRoute
  '/editor': typeof AppEditorRoute
  '/login': typeof AppLoginRoute
  '/pedido': typeof AppPedidoRoute
  '/pedidos': typeof AppPedidosRoute
  '/subidas': typeof AppSubidasRoute
  '/admin/comisiones': typeof AdminComisionesRoute
  '/admin/comisionesF': typeof AdminComisionesFRoute
  '/admin/cuentas': typeof AdminCuentasRoute
  '/admin/editor': typeof AdminEditorRoute
  '/admin/fotos': typeof AdminFotosRoute
  '/admin/informes': typeof AdminInformesRoute
  '/admin/login': typeof AdminLoginRoute
  '/admin/miscomisiones': typeof AdminMiscomisionesRoute
  '/admin/subidas': typeof AdminSubidasRoute
  '/admin/ubicaciones': typeof AdminUbicacionesRoute
  '/': typeof AppIndexRoute
  '/admin/': typeof AdminIndexRoute
  '/admin/config/editFoto': typeof AdminConfigEditFotoRoute
  '/admin/config/personal': typeof AdminConfigPersonalRoute
  '/admin/config/temporada': typeof AdminConfigTemporadaRoute
  '/admin/pedido/anular': typeof AdminPedidoAnularRoute
  '/admin/pedidos/cerrados': typeof AdminPedidosCerradosRoute
  '/admin/pedidos/print': typeof AdminPedidosPrintRoute
  '/admin/config': typeof AdminConfigIndexRoute
  '/admin/pedido': typeof AdminPedidoIndexRoute
  '/admin/pedidos': typeof AdminPedidosIndexRoute
}
export interface FileRoutesByTo {
  '/buscador': typeof AppBuscadorRoute
  '/editor': typeof AppEditorRoute
  '/login': typeof AppLoginRoute
  '/pedido': typeof AppPedidoRoute
  '/pedidos': typeof AppPedidosRoute
  '/subidas': typeof AppSubidasRoute
  '/admin/comisiones': typeof AdminComisionesRoute
  '/admin/comisionesF': typeof AdminComisionesFRoute
  '/admin/cuentas': typeof AdminCuentasRoute
  '/admin/editor': typeof AdminEditorRoute
  '/admin/fotos': typeof AdminFotosRoute
  '/admin/informes': typeof AdminInformesRoute
  '/admin/login': typeof AdminLoginRoute
  '/admin/miscomisiones': typeof AdminMiscomisionesRoute
  '/admin/subidas': typeof AdminSubidasRoute
  '/admin/ubicaciones': typeof AdminUbicacionesRoute
  '/': typeof AppIndexRoute
  '/admin': typeof AdminIndexRoute
  '/admin/config/editFoto': typeof AdminConfigEditFotoRoute
  '/admin/config/personal': typeof AdminConfigPersonalRoute
  '/admin/config/temporada': typeof AdminConfigTemporadaRoute
  '/admin/pedido/anular': typeof AdminPedidoAnularRoute
  '/admin/pedidos/cerrados': typeof AdminPedidosCerradosRoute
  '/admin/pedidos/print': typeof AdminPedidosPrintRoute
  '/admin/config': typeof AdminConfigIndexRoute
  '/admin/pedido': typeof AdminPedidoIndexRoute
  '/admin/pedidos': typeof AdminPedidosIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteRouteWithChildren
  '/admin': typeof AdminRouteRouteWithChildren
  '/_app/buscador': typeof AppBuscadorRoute
  '/_app/editor': typeof AppEditorRoute
  '/_app/login': typeof AppLoginRoute
  '/_app/pedido': typeof AppPedidoRoute
  '/_app/pedidos': typeof AppPedidosRoute
  '/_app/subidas': typeof AppSubidasRoute
  '/admin/comisiones': typeof AdminComisionesRoute
  '/admin/comisionesF': typeof AdminComisionesFRoute
  '/admin/cuentas': typeof AdminCuentasRoute
  '/admin/editor': typeof AdminEditorRoute
  '/admin/fotos': typeof AdminFotosRoute
  '/admin/informes': typeof AdminInformesRoute
  '/admin/login': typeof AdminLoginRoute
  '/admin/miscomisiones': typeof AdminMiscomisionesRoute
  '/admin/subidas': typeof AdminSubidasRoute
  '/admin/ubicaciones': typeof AdminUbicacionesRoute
  '/_app/': typeof AppIndexRoute
  '/admin/': typeof AdminIndexRoute
  '/admin/config/editFoto': typeof AdminConfigEditFotoRoute
  '/admin/config/personal': typeof AdminConfigPersonalRoute
  '/admin/config/temporada': typeof AdminConfigTemporadaRoute
  '/admin/pedido/anular': typeof AdminPedidoAnularRoute
  '/admin/pedidos/cerrados': typeof AdminPedidosCerradosRoute
  '/admin/pedidos/print': typeof AdminPedidosPrintRoute
  '/admin/config/': typeof AdminConfigIndexRoute
  '/admin/pedido/': typeof AdminPedidoIndexRoute
  '/admin/pedidos/': typeof AdminPedidosIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/admin'
    | '/buscador'
    | '/editor'
    | '/login'
    | '/pedido'
    | '/pedidos'
    | '/subidas'
    | '/admin/comisiones'
    | '/admin/comisionesF'
    | '/admin/cuentas'
    | '/admin/editor'
    | '/admin/fotos'
    | '/admin/informes'
    | '/admin/login'
    | '/admin/miscomisiones'
    | '/admin/subidas'
    | '/admin/ubicaciones'
    | '/'
    | '/admin/'
    | '/admin/config/editFoto'
    | '/admin/config/personal'
    | '/admin/config/temporada'
    | '/admin/pedido/anular'
    | '/admin/pedidos/cerrados'
    | '/admin/pedidos/print'
    | '/admin/config'
    | '/admin/pedido'
    | '/admin/pedidos'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/buscador'
    | '/editor'
    | '/login'
    | '/pedido'
    | '/pedidos'
    | '/subidas'
    | '/admin/comisiones'
    | '/admin/comisionesF'
    | '/admin/cuentas'
    | '/admin/editor'
    | '/admin/fotos'
    | '/admin/informes'
    | '/admin/login'
    | '/admin/miscomisiones'
    | '/admin/subidas'
    | '/admin/ubicaciones'
    | '/'
    | '/admin'
    | '/admin/config/editFoto'
    | '/admin/config/personal'
    | '/admin/config/temporada'
    | '/admin/pedido/anular'
    | '/admin/pedidos/cerrados'
    | '/admin/pedidos/print'
    | '/admin/config'
    | '/admin/pedido'
    | '/admin/pedidos'
  id:
    | '__root__'
    | '/_app'
    | '/admin'
    | '/_app/buscador'
    | '/_app/editor'
    | '/_app/login'
    | '/_app/pedido'
    | '/_app/pedidos'
    | '/_app/subidas'
    | '/admin/comisiones'
    | '/admin/comisionesF'
    | '/admin/cuentas'
    | '/admin/editor'
    | '/admin/fotos'
    | '/admin/informes'
    | '/admin/login'
    | '/admin/miscomisiones'
    | '/admin/subidas'
    | '/admin/ubicaciones'
    | '/_app/'
    | '/admin/'
    | '/admin/config/editFoto'
    | '/admin/config/personal'
    | '/admin/config/temporada'
    | '/admin/pedido/anular'
    | '/admin/pedidos/cerrados'
    | '/admin/pedidos/print'
    | '/admin/config/'
    | '/admin/pedido/'
    | '/admin/pedidos/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRouteRoute: typeof AppRouteRouteWithChildren
  AdminRouteRoute: typeof AdminRouteRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AppRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/': {
      id: '/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/admin/ubicaciones': {
      id: '/admin/ubicaciones'
      path: '/ubicaciones'
      fullPath: '/admin/ubicaciones'
      preLoaderRoute: typeof AdminUbicacionesRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/subidas': {
      id: '/admin/subidas'
      path: '/subidas'
      fullPath: '/admin/subidas'
      preLoaderRoute: typeof AdminSubidasRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/miscomisiones': {
      id: '/admin/miscomisiones'
      path: '/miscomisiones'
      fullPath: '/admin/miscomisiones'
      preLoaderRoute: typeof AdminMiscomisionesRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/login': {
      id: '/admin/login'
      path: '/login'
      fullPath: '/admin/login'
      preLoaderRoute: typeof AdminLoginRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/informes': {
      id: '/admin/informes'
      path: '/informes'
      fullPath: '/admin/informes'
      preLoaderRoute: typeof AdminInformesRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/fotos': {
      id: '/admin/fotos'
      path: '/fotos'
      fullPath: '/admin/fotos'
      preLoaderRoute: typeof AdminFotosRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/editor': {
      id: '/admin/editor'
      path: '/editor'
      fullPath: '/admin/editor'
      preLoaderRoute: typeof AdminEditorRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/cuentas': {
      id: '/admin/cuentas'
      path: '/cuentas'
      fullPath: '/admin/cuentas'
      preLoaderRoute: typeof AdminCuentasRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/comisionesF': {
      id: '/admin/comisionesF'
      path: '/comisionesF'
      fullPath: '/admin/comisionesF'
      preLoaderRoute: typeof AdminComisionesFRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/comisiones': {
      id: '/admin/comisiones'
      path: '/comisiones'
      fullPath: '/admin/comisiones'
      preLoaderRoute: typeof AdminComisionesRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/_app/subidas': {
      id: '/_app/subidas'
      path: '/subidas'
      fullPath: '/subidas'
      preLoaderRoute: typeof AppSubidasRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/pedidos': {
      id: '/_app/pedidos'
      path: '/pedidos'
      fullPath: '/pedidos'
      preLoaderRoute: typeof AppPedidosRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/pedido': {
      id: '/_app/pedido'
      path: '/pedido'
      fullPath: '/pedido'
      preLoaderRoute: typeof AppPedidoRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/login': {
      id: '/_app/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof AppLoginRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/editor': {
      id: '/_app/editor'
      path: '/editor'
      fullPath: '/editor'
      preLoaderRoute: typeof AppEditorRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/buscador': {
      id: '/_app/buscador'
      path: '/buscador'
      fullPath: '/buscador'
      preLoaderRoute: typeof AppBuscadorRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/admin/pedidos/': {
      id: '/admin/pedidos/'
      path: '/pedidos'
      fullPath: '/admin/pedidos'
      preLoaderRoute: typeof AdminPedidosIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/pedido/': {
      id: '/admin/pedido/'
      path: '/pedido'
      fullPath: '/admin/pedido'
      preLoaderRoute: typeof AdminPedidoIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/config/': {
      id: '/admin/config/'
      path: '/config'
      fullPath: '/admin/config'
      preLoaderRoute: typeof AdminConfigIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/pedidos/print': {
      id: '/admin/pedidos/print'
      path: '/pedidos/print'
      fullPath: '/admin/pedidos/print'
      preLoaderRoute: typeof AdminPedidosPrintRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/pedidos/cerrados': {
      id: '/admin/pedidos/cerrados'
      path: '/pedidos/cerrados'
      fullPath: '/admin/pedidos/cerrados'
      preLoaderRoute: typeof AdminPedidosCerradosRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/pedido/anular': {
      id: '/admin/pedido/anular'
      path: '/pedido/anular'
      fullPath: '/admin/pedido/anular'
      preLoaderRoute: typeof AdminPedidoAnularRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/config/temporada': {
      id: '/admin/config/temporada'
      path: '/config/temporada'
      fullPath: '/admin/config/temporada'
      preLoaderRoute: typeof AdminConfigTemporadaRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/config/personal': {
      id: '/admin/config/personal'
      path: '/config/personal'
      fullPath: '/admin/config/personal'
      preLoaderRoute: typeof AdminConfigPersonalRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/config/editFoto': {
      id: '/admin/config/editFoto'
      path: '/config/editFoto'
      fullPath: '/admin/config/editFoto'
      preLoaderRoute: typeof AdminConfigEditFotoRouteImport
      parentRoute: typeof AdminRouteRoute
    }
  }
}

interface AppRouteRouteChildren {
  AppBuscadorRoute: typeof AppBuscadorRoute
  AppEditorRoute: typeof AppEditorRoute
  AppLoginRoute: typeof AppLoginRoute
  AppPedidoRoute: typeof AppPedidoRoute
  AppPedidosRoute: typeof AppPedidosRoute
  AppSubidasRoute: typeof AppSubidasRoute
  AppIndexRoute: typeof AppIndexRoute
}

const AppRouteRouteChildren: AppRouteRouteChildren = {
  AppBuscadorRoute: AppBuscadorRoute,
  AppEditorRoute: AppEditorRoute,
  AppLoginRoute: AppLoginRoute,
  AppPedidoRoute: AppPedidoRoute,
  AppPedidosRoute: AppPedidosRoute,
  AppSubidasRoute: AppSubidasRoute,
  AppIndexRoute: AppIndexRoute,
}

const AppRouteRouteWithChildren = AppRouteRoute._addFileChildren(
  AppRouteRouteChildren,
)

interface AdminRouteRouteChildren {
  AdminComisionesRoute: typeof AdminComisionesRoute
  AdminComisionesFRoute: typeof AdminComisionesFRoute
  AdminCuentasRoute: typeof AdminCuentasRoute
  AdminEditorRoute: typeof AdminEditorRoute
  AdminFotosRoute: typeof AdminFotosRoute
  AdminInformesRoute: typeof AdminInformesRoute
  AdminLoginRoute: typeof AdminLoginRoute
  AdminMiscomisionesRoute: typeof AdminMiscomisionesRoute
  AdminSubidasRoute: typeof AdminSubidasRoute
  AdminUbicacionesRoute: typeof AdminUbicacionesRoute
  AdminIndexRoute: typeof AdminIndexRoute
  AdminConfigEditFotoRoute: typeof AdminConfigEditFotoRoute
  AdminConfigPersonalRoute: typeof AdminConfigPersonalRoute
  AdminConfigTemporadaRoute: typeof AdminConfigTemporadaRoute
  AdminPedidoAnularRoute: typeof AdminPedidoAnularRoute
  AdminPedidosCerradosRoute: typeof AdminPedidosCerradosRoute
  AdminPedidosPrintRoute: typeof AdminPedidosPrintRoute
  AdminConfigIndexRoute: typeof AdminConfigIndexRoute
  AdminPedidoIndexRoute: typeof AdminPedidoIndexRoute
  AdminPedidosIndexRoute: typeof AdminPedidosIndexRoute
}

const AdminRouteRouteChildren: AdminRouteRouteChildren = {
  AdminComisionesRoute: AdminComisionesRoute,
  AdminComisionesFRoute: AdminComisionesFRoute,
  AdminCuentasRoute: AdminCuentasRoute,
  AdminEditorRoute: AdminEditorRoute,
  AdminFotosRoute: AdminFotosRoute,
  AdminInformesRoute: AdminInformesRoute,
  AdminLoginRoute: AdminLoginRoute,
  AdminMiscomisionesRoute: AdminMiscomisionesRoute,
  AdminSubidasRoute: AdminSubidasRoute,
  AdminUbicacionesRoute: AdminUbicacionesRoute,
  AdminIndexRoute: AdminIndexRoute,
  AdminConfigEditFotoRoute: AdminConfigEditFotoRoute,
  AdminConfigPersonalRoute: AdminConfigPersonalRoute,
  AdminConfigTemporadaRoute: AdminConfigTemporadaRoute,
  AdminPedidoAnularRoute: AdminPedidoAnularRoute,
  AdminPedidosCerradosRoute: AdminPedidosCerradosRoute,
  AdminPedidosPrintRoute: AdminPedidosPrintRoute,
  AdminConfigIndexRoute: AdminConfigIndexRoute,
  AdminPedidoIndexRoute: AdminPedidoIndexRoute,
  AdminPedidosIndexRoute: AdminPedidosIndexRoute,
}

const AdminRouteRouteWithChildren = AdminRouteRoute._addFileChildren(
  AdminRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AppRouteRoute: AppRouteRouteWithChildren,
  AdminRouteRoute: AdminRouteRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
